import { useQuery } from '@tanstack/react-query'
import type { RegistrationStatusResponseDto } from '@fp3/shared'
import { authApi } from '../api/authApi'

export const useRegistrationStatus = () => {
  return useQuery<RegistrationStatusResponseDto>({
    queryKey: ['auth', 'registration-status'],
    queryFn: authApi.getRegistrationStatus,
    staleTime: 5 * 60_000,
  })
}
